export type typeInfoData = {
  [key: string]: { id: number; label: string }[];
};

export const InfoData: typeInfoData = {
  mainOfficePhysical: [
    {
      id: 1,
      label: `This is the physical location of the entity. This address cannot be aP.O. box.`,
    },

    {
      id: 2,
      label: `Type the business name first then the street address and select from the
            options in the dropdown. Manually adding an address will require a
            supervisor override.`,
    },

    {
      id: 3,
      label: `A green checkmark indicates the location was created by API. A red icon
            means all fields for the location were entered manually by a user.`,
    },

    {
      id: 4,
      label: `A green checkmark indicates an API was used to create the location. A
            red icon means a user entered all fields for the location manually.`,
    },
  ],
  mainOfficeMailing: [
    {
      id: 5,
      label: `This is the mailing address for the entity. This address can be a P.O.box.`,
    },

    {
      id: 6,
      label: `Type the business name first then the street address and select from
            the options in the dropdown. Manually adding an address will require a
            supervisor override.`,
    },

    {
      id: 7,
      label: `A green checkmark indicates an API was used to create the location. A
            red icon means a user entered all fields for the location manually.`,
    },
  ],
  email: [
    {
      id: 8,
      label: `This is the primary email address for the entity.`,
    },
    {
      id: 9,
      label: `A green checkmark indicates the email address was verified by the
            account holder to be valid. A red icon means the account holder did
            not complete the verification process.`,
    },
  ],
  primaryContactNumber: [
    {
      id: 10,
      label: `This contact number should be used first when contacting the entity.`,
    },
    {
      id: 11,
      label: `A green checkmark indicates an API was used to confirm the number is
            valid. A red icon means the phone number could not be validated by API
            and could be out of service or incorrect.`,
    },
    {
      id: 12,
      label: `The left icon indicates if the API was able to determine if it was a
            mobile device or landline.`,
    },
  ],
  secondaryContactNumber: [
    {
      id: 13,
      label: `This contact number should be used second when contacting the entity
            and they cannot be reached by their primary number.`,
    },
    {
      id: 14,
      label: `A green checkmark indicates an API was used to confirm the number is
            valid. A red icon means the phone number could not be validated by API
            and could be out of service or incorrect.`,
    },
    {
      id: 15,
      label: `The left icon indicates if the API was able to determine if it was a
            mobile device or landline.`,
    },
  ],
  payorUserAccessTitle: [
    {
      id: 16,
      label: `This page is used to grant the entity's users access to the Payor portal.  This area grants access to users outside the organization ONLY.  For users within the organization, you may grant access to them using the Administration Module.`,
    },
  ],
  contactsAgreementsTable: [
    {
      id: 17,
      label: `This space is used to track and log contracts held with an entity.`,
    },
  ],
  ratesTable: [
    {
      id: 18,
      label: `This space is used to enter service reimbursement rates paid by the entity.`,
    },
  ],
  payorDocumentsTable: [
    {
      id: 19,
      label: `This area is general file repository for the entity.`,
    },
  ],
  factoringAgreementTable: [
    {
      id: 20,
      label: `This space is used to enter service reimbursement rates paid by the entity.`,
    },
  ],
  contractorRatesTable: [
    {
      id: 21,
      label: `This space is used to enter service reimbursement rates paid by the entity.`,
    },
  ],
};

export type TitleInfoData = {
  pathName: string;
  title: string;
  className: string;
};

export const TitleInfoData: TitleInfoData[] = [
  {
    pathName: '/ride-reports',
    title: 'Ride Dashboard',
    className: '',
  },
  {
    pathName: '/member-reports',
    title: 'Member Dashboard',
    className: '',
  },
  {
    pathName: '/contractor-rejected-reports',
    title: 'Pending Rides Report',
    className: 'title-reports-dashboard',
  },
  {
    pathName: '/rideshare-reports',
    title: 'Rideshare Dashboard',
    className: 'title-reports-dashboard',
  },
];
